import React, {Component} from "react";
import PropTypes from 'prop-types';
import {Card, CardBody, CardFooter,Row, Col, Progress, Table, Badge,Nav,NavItem, TabContent,TabPane,NavLink} from "reactstrap";
import classNames from 'classnames';
import {mapToCssModules} from 'reactstrap/lib/utils';
import classnames from "classnames";

const propTypes = {
    header: PropTypes.string,
    mainText: PropTypes.string,
    icon: PropTypes.string,
    color: PropTypes.string,
    variant: PropTypes.string,
    footer: PropTypes.bool,
    link: PropTypes.string,
    children: PropTypes.node,
    className: PropTypes.string,
    cssModule: PropTypes.object,
    breakerAux: PropTypes.number

};

const defaultProps = {
    header: '$1,999.50',
    mainText: 'Income',
    icon: "fa fa-bolt",
    color: 'primary',
    variant: "0",
    link: "#",
    breakerAux: false

};



class Generators extends Component {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.state = {
            activeTab: '1'
        };
    }

    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }
    render() {
        const { breakerAux
            , className, cssModule, header, mainText, icon, color, footer, link, children, variant, ...attributes} = this.props;

        // demo purposes only
        const padding = (variant === '0' ? {card: "p-3", icon: "p-3", lead: "mt-2"} : ( variant === "1" ? {
            card: "p-0", icon: "p-4", lead: "pt-3" } : {card: "p-0", icon: "p-4 px-5", lead: "pt-3"}));

        const card = {style: "card-body clearfix", color: color, icon: icon, classes: ""};
        card.classes = mapToCssModules(classNames(className, card.style, padding.card), cssModule);

        const lead = {style: "h5 mb-0", color: color, classes: ""};
        lead.classes = classNames(lead.style, 'text-black-50', padding.lead);

        const blockIcon = function (icon) {
            const classes = classNames(icon, 'bg-light', padding.icon, "font-2xl mr-3 float-left");
            return (<i className={ classes }></i>);
        };

        const cardFooter = function () {
            if (footer) {
                return (
                    <CardFooter className="px-3 py-2">
                        <a className="font-weight-bold font-xs btn-block text-muted" href={link}>View More
                            <i className="fa fa-bolt float-right font-lg"></i></a>
                    </CardFooter>
                );
            }
        };
        return (
            <Card>
                <CardBody className={ card.classes } {...attributes}>
                    { blockIcon(card.icon) }
                    <div className={ lead.classes }>{ header }</div>
                    <div className="text-muted text-uppercase font-weight-bold font-xs">{ mainText }</div>
                    <hr />
                    <Row>
                        <Col xs="6" sm="6" lg="6">
                            <div className="text-muted text-uppercase font-weight-normal font-xs">Breaker</div>
                        </Col>
                        <Col xs="6" sm="6" lg="6">
                            <div>{breakerAux ? <Badge color="danger">Closed</Badge> : <Badge color="success">Open</Badge> }</div>
                        </Col>
                    </Row>

                </CardBody>
                { cardFooter() }
            </Card>
        )
    }
}

Generators.propTypes = propTypes;
Generators.defaultProps = defaultProps;

export default Generators;


// WEBPACK FOOTER //
// ./src/views/site/TieSchema/Ties.js